import { twMerge } from 'tailwind-merge';

export const IconX = ({ className, color = "#000000", size = '24' }) => {
  return (
    <svg className={twMerge('dark:[&_path]:fill-[#A9C7FF] dark:[&_path]:stroke-[#A9C7FF] dark:[&:hover_path]:fill-[#FCBC00] dark:[&:hover_path]:stroke-[#FCBC00] [&:hover_path]:fill-[#FCBC00] [&:hover_path]:stroke-[#FCBC00]', className)} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 3L10.3331 13H13L5.66688 3H3ZM3 13L7.23 8.77L3 13ZM8.7675 7.2325L13 3L8.7675 7.2325Z" fill={color} />
      <path d="M3 13L7.23 8.77M8.7675 7.2325L13 3M3 3L10.3331 13H13L5.66688 3H3Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}